import React, { useRef, useState } from "react";
import { getEsignPending } from "../../Services/AllotmentEsign";
import { errorTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import AllotmentEsignModal from "./AllotmentEsignModal";
import { LOAD_ERROR, pendingErrorText } from "./esignReturn";

// requireEsign(allotmentPaymentId, next, { summary })
// - no allotmentPaymentId, or the server says no eSign is required → next() runs straight away
// - pending cannot be loaded → error toast, next() does not run
// - otherwise the eSign pop-up opens for the first pending signer; the customer leaves for Surepass
//   and comes back to the Dashboard (see esignReturn.js). next() is not run in that case: the next
//   Pay Now checks again and goes ahead once every signature is done.
export default function useAllotmentEsign() {
	const [esign, setEsign] = useState(null);
	const checking = useRef(false);

	const requireEsign = async (allotmentPaymentId, next, { summary = [] } = {}) => {
		if (!allotmentPaymentId) return next();
		if (checking.current) return;
		checking.current = true;
		let pending;
		presentLoader();
		try {
			pending = await getEsignPending(allotmentPaymentId);
		} catch (err) {
			console.error("allotment eSign pending error:", err);
			errorTost(pendingErrorText(err));
			return;
		} finally {
			dismissLoader();
			checking.current = false;
		}
		if (!pending?.required) return next();
		const items = pending.items || [];
		if (!items.length) {
			// required but nothing to sign: do not let the payment through on a bad response
			errorTost(LOAD_ERROR);
			return;
		}
		setEsign({ key: Date.now(), allotmentPaymentId, title: pending.title, item: items[0], signerCount: items.length, summary });
	};

	const esignModal = esign ? (
		<AllotmentEsignModal
			key={esign.key}
			open={true}
			handleClose={() => setEsign(null)}
			allotmentPaymentId={esign.allotmentPaymentId}
			title={esign.title}
			item={esign.item}
			signerNo={1}
			signerCount={esign.signerCount}
			summary={esign.summary}
		/>
	) : null;

	return { requireEsign, esignModal };
}
